import './checkout.styles.scss'

import CheckoutItem from '../../components/checkout-item/checkout-item.component'

import {useSelector} from 'react-redux'
import {selectCartTotal, selectCartItems} from '../../store/cart/cart.selector'

const Checkout = () =>{

    const cartItems = useSelector(selectCartItems)
    const cartTotal = useSelector(selectCartTotal)

    return(
        <div className="checkout-container">
            <div className="checkout-header">
                <div className="header-block">
                    <span>Product</span>
                </div>
                <div className="header-block">
                    <span>Description</span>
                </div>
                <div className="header-block">
                    <span>quantity</span>
                </div>
                <div className="header-block">
                    <span>Price</span>
                </div>
                <div className="header-block">
                    <span>Remove</span>
                </div>
            </div>
                {
                    cartItems.map((item)=>{
                        // return console.log(item)
                        return <CheckoutItem key={item.id} cartItem={item} />
                    })
                }
                <span className="total">Total:{cartTotal}</span>
        </div>
    )
}

export default Checkout